import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";
import { footprintPrice } from "../../../components/store";

export class RookieBabyShopSystemStrategy extends ShopifyShopSystemStrategy {
  isReOffsetting: boolean = false;

  registerEventHandlers(): void {
    window.addEventListener("ComponentRendered", (x) => {
      if (x.detail.type == "rookiebabyButton") {
        const interval = setInterval(() => {
          const element = document
            .querySelector(".Cart__Recap")
            ?.querySelector(".pina-app");
          if (!element) {
            window.dispatchEvent(new CustomEvent("CartReRendered", {}));
          }
        }, 100);
        setTimeout(() => clearInterval(interval), 3000);
      }
    });

    // Check if we need to re-offset the cart when the footprint price changes.
    // This also catches the case of adding a product on a page that
    // doesn't load the plugin, and then navigates to a page that has
    // the plugin, as this will trigger once the offset is known.
    footprintPrice.subscribe(async (value) => {
      const cart = await this.getCart();
      if (!cart) return;
      const offset = this.getOffsetItem(cart);
      if (value == 0 && (!offset || cart.items.length > 1)) return;
      if (!offset) return;
      // If our price already matches, nothing needs to happen.
      if (offset.price != Math.round(value * 100)) {
        this.isReOffsetting = true;
        // Refresh if this if the offset is the last item in the cart.
        await this.toggleOffset(false, cart!.items.length === 1);
        this.isReOffsetting = false;
        if (cart!.items.length > 1) await this.toggleOffset(true);
      }
    });
  }

  async refreshCart(): Promise<void> {
    const cart = await this.getCart();
    const offset = this.getOffsetItem(cart);
    if (!offset) window.location.reload();
  }
}
